import React from 'react';
import ReactDOM from 'react-dom/client';
import '../client/i18n';
import frFR from 'antd/locale/fr_FR';
import ActiveSubstanceSearchPage from '@client/feature/activeSubstance/SearchPage';
import { ConfigProvider } from 'antd';
import theme from '@client/theme/theme';
import AppQueryClientProvider from '@client/providers/QueryClientProvider';
import { NuqsAdapter } from 'nuqs/adapters/react';

const root = document.getElementById('activeSubstanceSearch');

/**
 * This app is responsible for the active substance search, and details page
 *
 * @returns {Element}
 * @constructor
 */
const ActiveSubstanceSearchApp = () => {
  return (
    <NuqsAdapter>
      <AppQueryClientProvider>
        <ConfigProvider theme={theme} locale={frFR}>
          <ActiveSubstanceSearchPage />
        </ConfigProvider>
      </AppQueryClientProvider>
    </NuqsAdapter>
  );
};

/**
 * Render the application
 * we can add redux provider here
 */
ReactDOM.createRoot(root).render(<ActiveSubstanceSearchApp />);
